// /components/Registration/RegistrationCompleted.js

import React from "react";

const RegistrationCompleted = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded shadow-md">
        <h2 className="text-2xl font-bold text-center text-gray-700">
          Registration Completed
        </h2>
        <p className="text-center text-gray-600">
          Thank you for completing your registration. You can now proceed to use the app.
        </p>
        <div className="text-center">
          <a
            href="/user-dashboard"
            className="inline-block px-6 py-2 mt-4 text-white bg-indigo-500 rounded hover:bg-indigo-600"
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

export default RegistrationCompleted;
